// Runtime environment configuration
declare global {
  interface Window {
    _env_: {
      REACT_APP_BASE_API?: string;
      REACT_APP_VERSION?: string;
      NODE_ENV?: string;
    };
  }
}

export const Environment = {
  BASE_API: window._env_?.REACT_APP_BASE_API || process.env.REACT_APP_BASE_API,
  VERSION: window._env_?.REACT_APP_VERSION || process.env.REACT_APP_VERSION,
  NODE_ENV: window._env_?.NODE_ENV || process.env.NODE_ENV || "production",
};
